import { qs, qsa } from './utils'
import { gsap, Power4 } from 'gsap'

class Search {
  constructor() {
    isOpen: false
    isAnimating: false
    bindedOpen: null
    bindedClose: null
  }

  init() {
    this.search = qs('[data-search]')
    this.content = qs('[data-content]', this.search)
    this.toggleOpen = qs('[data-open]', this.search)
    this.disappear = qsa('[data-header-disappear]')
    this.form = qs('[data-form]', this.search)
    this.input = qs('[data-input]', this.search)
    this.toggleClose = qs('[data-close]', this.search)

    this.initListeners()
  }


  initListeners() {
    this.bindedOpen = this.handleOpen.bind(this)
    this.bindedClose = this.handleClose.bind(this)

    this.toggleOpen.addEventListener('click', this.bindedOpen)
    this.toggleClose.addEventListener('click', this.bindedClose)
  }

  removeListeners() {
    this.toggleOpen.removeEventListener('click', this.bindedOpen)
    this.toggleClose.removeEventListener('click', this.bindedClose)
  }

  handleOpen() {
    if (this.isAnimating || this.isOpen) return

    this.isOpen = true
    this.isAnimating = true
    this.searchOpen()
  }

  handleClose() {
    if (this.isAnimating || !this.isOpen) return

    this.isOpen = false
    this.isAnimating = true
    this.searchClose()
  }

  searchOpen() {
    const isMobile = window.innerWidth < 768

    const tl = gsap.timeline({ onComplete: () => {
      this.isAnimating = false
      this.input.focus()
    }})

    if (isMobile) {
      tl
        .to(this.disappear, {
          duration: 0.6,
          autoAlpha: 0,
          ease: Power4.easeOut
        })
    }

    tl
      .to(this.content, {
        duration: 0.8,
        width: 'auto',
        ease: Power4.easeOut
      })
      .to([this.form, this.toggleClose], {
        duration: 0.6,
        autoAlpha: 1,
        stagger: 0.04,
        ease: Power4.easeOut
      }, '-=0.4')
  }

  searchClose() {
    const isMobile = window.innerWidth < 768

    const tl = gsap.timeline({ onComplete: () => {
      this.isAnimating = false
      this.input.value = ''
    }})

    tl
      .to([this.form, this.toggleClose], {
        duration: 0.6,
        autoAlpha: 0,
        stagger: 0.04,
        ease: Power4.easeOut
      })
      .to(this.content, {
        duration: 0.8,
        width: 0,
        ease: Power4.easeOut
      }, '-=0.4')
      .set([this.form, this.toggleClose, this.content], { clearProps: 'all' })

    if (isMobile) {
      tl
        .to(this.disappear, {
          duration: 0.6,
          autoAlpha: 1,
          ease: Power4.easeOut
        })
    }
  }
}

export default new Search()

